import React from 'react';
import classNames from 'classnames';
import { IconProps, IconOtherProps, IconChevronProps } from './Icons.types';
import './Icons.scss';

/**
 * Icon Components
 * Following DDD principles - UI layer components
 *
 * Usage:
 * <IconDashboard isActive={true} />
 * <IconCustomers isBlack={true} isRelative={true} />
 */

/**
 * IconCustomers - Example icon component
 * Shows customers icon with different states (gray/white/black)
 */
export const IconCustomers = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-customers-gray': !props.isBlack && !props.isActive,
        'icon-customers-white': !props.isBlack && props.isActive,
        'icon-customers-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconClients - Clients icon
 */
export const IconClients = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-clients-gray': !props.isBlack && !props.isActive,
        'icon-clients-white': !props.isBlack && props.isActive,
        'icon-clients-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconDashboard - Dashboard icon
 */
export const IconDashboard = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-dashboard-gray': !props.isActive,
        'icon-dashboard-black': props.isActive,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconAnalytics - Analytics icon
 */
export const IconAnalytics = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-analytics-gray': !props.isBlack && !props.isActive,
        'icon-analytics-white': !props.isBlack && props.isActive,
        'icon-analytics-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconUsers - Users icon
 */
export const IconUsers = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-users-gray': !props.isBlack && !props.isActive,
        'icon-users-white': !props.isBlack && props.isActive,
        'icon-users-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconOrders - Orders icon
 */
export const IconOrders = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-orders-gray': !props.isBlack && !props.isActive,
        'icon-orders-white': !props.isBlack && props.isActive,
        'icon-orders-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconCategories - Categories icon
 */
export const IconCategories = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-categories-gray': !props.isBlack && !props.isActive,
        'icon-categories-white': !props.isBlack && props.isActive,
        'icon-categories-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconRoles - Roles icon
 */
export const IconRoles = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-roles-gray': !props.isBlack && !props.isActive,
        'icon-roles-white': !props.isBlack && props.isActive,
        'icon-roles-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconReports - Reports icon
 */
export const IconReports = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-reports-gray': !props.isBlack && !props.isActive,
        'icon-reports-white': !props.isBlack && props.isActive,
        'icon-reports-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconNotifications - Notifications icon
 */
export const IconNotifications = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-notifications-gray': !props.isBlack && !props.isActive,
        'icon-notifications-white': !props.isBlack && props.isActive,
        'icon-notifications-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconSubscription - Subscription icon
 */
export const IconSubscription = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-subscription-gray': !props.isBlack && !props.isActive,
        'icon-subscription-white': !props.isBlack && props.isActive,
        'icon-subscription-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconAdmins - Admins icon
 */
export const IconAdmins = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-admins-gray': !props.isBlack && !props.isActive,
        'icon-admins-white': !props.isBlack && props.isActive,
        'icon-admins-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconSettings - Settings icon
 */
export const IconSettings = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-settings-gray': !props.isBlack && !props.isActive,
        'icon-settings-white': !props.isBlack && props.isActive,
        'icon-settings-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconFaq - FAQ icon
 */
export const IconFaq = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-faq-gray': !props.isBlack && !props.isActive,
        'icon-faq-white': !props.isBlack && props.isActive,
        'icon-faq-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconCompanies - Companies icon
 */
export const IconCompanies = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-companies-gray': !props.isBlack && !props.isActive,
        'icon-companies-white': !props.isBlack && props.isActive,
        'icon-companies-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconProducts - Products icon
 */
export const IconProducts = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-products-gray': !props.isBlack && !props.isActive,
        'icon-products-white': !props.isBlack && props.isActive,
        'icon-products-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconChevron - Chevron icon (16x16)
 * Use isOpen / direction='up' to flip 180deg via CSS transition
 */
export const IconChevron = (props: IconChevronProps & { isOpen?: boolean }) => {
  const isUp = props.direction === 'up' || props.isOpen;
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-chevron': true,
          'icon-chevron--up': isUp,
          relative: props.isRelative,
        },
        props.className
      )}
    />
  );
};

/**
 * IconLogoTypeSmall - Small LogoType (174x32)
 * Brand logo for navigation and headers
 */
export const IconLogoTypeSmall = (props: IconProps) => {
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-logotype-small': true,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

// ============================================================================
// ACTION ICONS
// ============================================================================

export const IconEdit = (props: IconProps) => {
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-edit-gray': !props.isBlack && !props.isActive,
          'icon-edit-white': !props.isBlack && props.isActive,
          'icon-edit-black': props.isBlack,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

export const IconFilter = (props: IconProps) => {
  const isWhite = props.isActive || props.className?.includes('white');
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-filter-gray': !props.isBlack && !isWhite,
          'icon-filter-white': isWhite,
          'icon-filter-black': props.isBlack,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

/** Flow: <i class="icon icon-close-modal" /> */
export const IconCloseModal = (props: IconProps) => {
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-close-modal': true,
          relative: props.isRelative,
        },
        props.className
      )}
    />
  );
};

export const IconPlus = (props: IconProps) => {
  const isWhite = props.isActive || props.className?.includes('white');
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-plus-gray': !props.isBlack && !isWhite,
          'icon-plus-white': isWhite,
          'icon-plus-black': props.isBlack,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

export const IconRemove = (props: IconProps) => {
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-remove-gray': !props.isBlack && !props.isActive,
          'icon-remove-white': !props.isBlack && props.isActive,
          'icon-remove-black': props.isBlack,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

export const IconTrash = (props: IconOtherProps) => {
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-trash-red': props.isRed,
          'icon-trash-gray': !props.isRed && !props.isBlack && !props.isActive,
          'icon-trash-white': !props.isRed && !props.isBlack && props.isActive,
          'icon-trash-black': !props.isRed && props.isBlack,
          relative: props.isRelative,
        },
        props.className
      )}
    ></i>
  );
};

/**
 * IconViewTable — table view mode icon (20x20)
 */
export const IconViewTable = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-view-table-gray': !props.isActive && !props.isBlack,
        'icon-view-table-white': props.isActive && !props.isBlack,
        'icon-view-table-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconViewList — list/cards view mode icon (20x20)
 */
export const IconViewList = (props: IconProps) => {
  return (
    <i
      className={classNames({
        icon: true,
        'icon-view-list-gray': !props.isActive && !props.isBlack,
        'icon-view-list-white': props.isActive && !props.isBlack,
        'icon-view-list-black': props.isBlack,
        relative: props.isRelative,
      })}
    ></i>
  );
};

/**
 * IconMore — vertical 3-dots options icon.
 * Reusable in tables/menus (row actions, kebab menus).
 */
export const IconArrowLeft = (props: IconOtherProps) => {
  return (
    <i
      className={classNames(
        {
          icon: true,
          'icon-arrow-left-gray': props.isGray || (!props.isBlack && !props.isActive),
          'icon-arrow-left-black': props.isBlack,
          relative: props.isRelative,
        },
        props.className,
      )}
    />
  );
};

export const IconMore = (props: IconProps) => {
  const color = props.color ?? (props.isActive ? '#ffffff' : '#000000');
  return (
    <svg
      width={props.w ?? '16'}
      height={props.h ?? '16'}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(props.className, { relative: props.isRelative })}
    >
      <path
        d='M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z'
        fill={color}
      />
      <path
        d='M8 4C8.55228 4 9 3.55228 9 3C9 2.44772 8.55228 2 8 2C7.44772 2 7 2.44772 7 3C7 3.55228 7.44772 4 8 4Z'
        fill={color}
      />
      <path
        d='M8 14C8.55228 14 9 13.5523 9 13C9 12.4477 8.55228 12 8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14Z'
        fill={color}
      />
    </svg>
  );
};

// Add more icon components as needed following the same pattern
